/**
 * Timeline row icon + colors for Mongo case_history `kind` (Reddy-inspired, muted).
 */
export function caseHistoryKindVisual(kind) {
  const k = String(kind || '').toLowerCase();
  if (k === 'document_deleted' || k.includes('deleted')) {
    return { icon: 'ri-delete-bin-line', box: 'bg-slate-100 text-slate-500' };
  }
  if (k === 'document_archived' || k.includes('archived')) {
    return { icon: 'ri-archive-2-line', box: 'bg-slate-100 text-slate-500' };
  }
  if (k === 'document_restored' || k.includes('restored')) {
    return { icon: 'ri-arrow-go-back-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k === 'document_replaced' || k.includes('replaced')) {
    return { icon: 'ri-loop-left-line', box: 'bg-blue-50 text-blue-600' };
  }
  if (k === 'document_uploaded' || k.includes('upload')) {
    return { icon: 'ri-upload-cloud-2-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k === 'document_reviewed' || k.includes('review')) {
    return { icon: 'ri-file-check-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k === 'fee_change' || k.includes('fee')) {
    return { icon: 'ri-bank-card-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k.includes('referral')) {
    return { icon: 'ri-user-shared-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k.includes('asylum')) {
    return { icon: 'ri-shield-user-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k === 'advisor_assigned' || k.includes('assign')) {
    return { icon: 'ri-user-star-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k === 'case_opened') {
    return { icon: 'ri-folder-add-line', box: 'bg-slate-100 text-slate-500' };
  }
  if (k === 'needs_attention_changed') {
    return { icon: 'ri-alarm-warning-line', box: 'bg-amber-50 text-amber-700' };
  }
  if (k === 'reupload_requested') {
    return { icon: 'ri-refresh-line', box: 'bg-slate-100 text-slate-600' };
  }
  if (k === 'lead_qualification') {
    return { icon: 'ri-survey-line', box: 'bg-teal-50 text-teal-700' };
  }
  if (k === 'applicant_help_message') {
    return { icon: 'ri-question-line', box: 'bg-amber-50 text-amber-600' };
  }
  if (k === 'applicant_family_application_interest') {
    return { icon: 'ri-group-line', box: 'bg-amber-50 text-amber-600' };
  }
  if (k === 'help_message_replied' || k === 'family_application_interest_replied') {
    return { icon: 'ri-check-double-line', box: 'bg-emerald-50 text-emerald-600' };
  }
  return { icon: 'ri-history-line', box: 'bg-slate-100 text-slate-500' };
}
